exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-62cd38de]{font-weight:600}.secondary[data-v-62cd38de]{margin:.2rem 0 .5rem;font-size:.8em;color:#666}.submitted[data-v-62cd38de]{color:#666;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62cd38de","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/blocks/OrderMini.vue
// module id = 504
// module chunks = 0